// Core Technologies
export const core_skills = [
  { id: 1, skillName: "HTML5", level: "Experienced" },
  { id: 2, skillName: "CSS3 / SASS", level: "Experienced" },
  { id: 3, skillName: "JavaScript (ES6+)", level: "Experienced" },
  { id: 4, skillName: "TypeScript", level: "Intermediate" },
];

// Frameworks & Libraries
export const framework_skills = [
  { id: 1, skillName: "React.js", level: "Experienced" },
  { id: 2, skillName: "Redux / Redux Toolkit", level: "Experienced" },
  { id: 3, skillName: "REST APIs", level: "Experienced" },
  { id: 4, skillName: "Responsive Design", level: "Experienced" },
];

// Styling & UI
export const styling_skills = [
  { id: 1, skillName: "Tailwind CSS", level: "Experienced" },
  { id: 2, skillName: "Bootstrap", level: "Experienced" },
  { id: 3, skillName: "Material UI", level: "Experienced" },
];

// Tools & Testing
export const tools_skills = [
  { id: 1, skillName: "Git / GitHub", level: "Experienced" },
  { id: 2, skillName: "Swagger", level: "Experienced" },
  { id: 3, skillName: "Sentry", level: "Intermediate" },
];